const cards = {
  init() {
    const cards = document.querySelectorAll('.card');
    if (!cards.length) return;

    const observer = new window.IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    cards.forEach((card, i) => {
      card.style.transitionDelay = `${i * 0.07}s`;
      observer.observe(card);
    });
  }
};

export default cards;